// Copyright (C) 2020 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { connect } from 'react-redux';
// import { registerAsync } from 'actions/auth-actions';
// import RegisterPageComponent from 'components/register-page/register-page';
// import { UserConfirmation } from 'components/register-page/register-form';
import RedirectComponent from 'components/login-redirect/login-redirect'
import { CombinedState, UserAgreement } from 'reducers/interfaces';

import { loginWithSocialAsync } from 'actions/auth-actions';
import { BaseSocialApplication } from 'components/login-redirect/login-redirect'


interface StateToProps {
    fetching: boolean;
    redirectToLogin: boolean;
    userAgreements: UserAgreement[];
}

interface DispatchToProps {
    onLoginWithGoogle: typeof loginWithSocialAsync;
}

function mapStateToProps(state: CombinedState): StateToProps {
    return {
        redirectToLogin: state.auth.redirectToLogin,
        fetching: state.auth.fetching || state.userAgreements.fetching,
        userAgreements: state.userAgreements.list,
    };
}

function mapDispatchToProps(dispatch: any): DispatchToProps {
    return {
        onLoginWithGoogle: (app: BaseSocialApplication) => dispatch(loginWithSocialAsync(app))
    };
}

function RedirectGoogleContainer(props: StateToProps & DispatchToProps): JSX.Element {
    const { fetching, onLoginWithGoogle, redirectToLogin } = props
    return (
        <RedirectComponent redirectToLogin={redirectToLogin} serviceName="Google" fetching={fetching} onLogin={onLoginWithGoogle} />
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RedirectGoogleContainer);
